import React, { useState, useEffect } from "react";
import { Button } from 'primereact/button';
import { RadioButton } from "primereact/radiobutton";
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import 'primeicons/primeicons.css';
import Alertas from "../../alertas";

function RegistroOcorrencia({ setFraseTopo, setStage, regOcorrencia, medidaProtetiva, descumpriu, terceiroVitima, descrTerceiro, agressaoFilhos, presencaFilhos, setRegOcorrencia, setMedidaProtetiva, setDescumpriu, setTerceiroVitima, setDescrTerceiro, setAgressaoFilhos, setPresencaFilhos }) {

    const opcoesAgressaoFilhos = [
        { key: '1', name: 'Não, nunca agrediu' },
        { key: '2', name: 'Sim, apenas os(as) filhos(as) de outro(s) relacionamento(s)' },
        { key: '3', name: 'Sim, apenas os(as) filhos(as) do relacionamento com ele' },
        { key: '4', name: 'Sim, tanto os(as) filhos(as) do relacionamento com ele como os(as) de outro(s) relacionamento(s)' },
        { key: '5', name: 'Não tenho filhos(as)' },
    ];

    useEffect(() => {
        setFraseTopo("Há esperança e apoio para você.");
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className="app-main-mulher">

            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div>
                        <p className="labels"><strong>Você já registrou ocorrência policial ou formulou pedido de medida protetiva de urgência envolvendo essa mesma pessoa?</strong></p>
                        <div>
                            <div className="item-check-mulher">
                                <RadioButton value="Sim" onChange={(e) => setRegOcorrencia(e.value)} checked={regOcorrencia === 'Sim'} />
                                <label>Sim</label>
                            </div>
                            <div className="item-check-mulher">
                                <RadioButton value="Não" onChange={(e) => setRegOcorrencia(e.value)} checked={regOcorrencia === 'Não'} />
                                <label>Não</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div>
                        <p className="labels"><strong>Você possui medida protetiva ATIVA contra essa pessoa?</strong></p>
                        <div>
                            <div className="item-check-mulher">
                                <RadioButton value="Sim" onChange={(e) => setMedidaProtetiva(e.value)} checked={medidaProtetiva === 'Sim'} />
                                <label>Sim</label>
                            </div>
                            <div className="item-check-mulher">
                                <RadioButton value="Não" onChange={(e) => setMedidaProtetiva(e.value)} checked={medidaProtetiva === 'Não'} />
                                <label>Não</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div>
                        <p className="labels"><strong>Essa pessoa já descumpriu medida protetiva anteriormente?</strong></p>
                        <div>
                            <div className="item-check-mulher">
                                <RadioButton value="Sim" onChange={(e) => descumpriu(e.value)} checked={setDescumpriu === 'Sim'} />
                                <label>Sim</label>
                            </div>
                            <div className="item-check-mulher">
                                <RadioButton value="Não" onChange={(e) => setDescumpriu(e.value)} checked={descumpriu === 'Não'} />
                                <label>Não</label>
                            </div>
                            <div className="item-check-mulher">
                                <RadioButton value="Não tenho/tive medidas protetivas em relação a essa pessoa" onChange={(e) => setDescumpriu(e.value)} checked={descumpriu === 'Não tenho/tive medidas protetivas em relação a essa pessoa'} />
                                <label>Não tenho/tive medidas protetivas em relação a essa pessoa</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div>
                        <p className="labels"><strong>Algum terceiro foi vítima desta mesma pessoa? </strong></p>
                        <div>
                            <div className="item-check-mulher">
                                <RadioButton value="Sim" onChange={(e) => setTerceiroVitima(e.value)} checked={terceiroVitima === 'Sim'} />
                                <label>Sim</label>
                            </div>
                            <div className="item-check-mulher">
                                <RadioButton value="Não" onChange={(e) => setTerceiroVitima(e.value)} checked={terceiroVitima === 'Não'} />
                                <label>Não</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div style={{width:'100%'}}>
                        <p className="labels"><strong>Quem foi a outra vítima? Quando ocorreu a agressão? Utilize esse espaço para descrever o acontecido.</strong></p>
                        <InputTextarea rows={5} value={descrTerceiro} placeholder="Sua resposta" onChange={(e) => setDescrTerceiro(e.target.value)} />
                    </div>

                </div>

            </div>

            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div>
                        <p className="labels"><strong>Essa pessoa já agrediu física ou verbalmente seus/suas filhos(as)?</strong></p>
                        <div>
                            {opcoesAgressaoFilhos.map((category) => {
                                return (
                                    <div key={category.key} className="item-check-mulher">
                                        <RadioButton inputId={category.key} name="category" value={category} onChange={(e) => setAgressaoFilhos(e.value)} checked={agressaoFilhos.key === category.key} />
                                        <label htmlFor={category.key} className="ml-2">{category.name}</label>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div>
                        <p className="labels"><strong>Seu(s) filho(s) já presenciaram ato(s) de violência física ou verbal da outra pessoa contra você?</strong></p>
                        <div>
                            <div className="item-check-mulher">
                                <RadioButton value="Sim" onChange={(e) => setPresencaFilhos(e.value)} checked={presencaFilhos === 'Sim'} />
                                <label>Sim</label>
                            </div>
                            <div className="item-check-mulher">
                                <RadioButton value="Não" onChange={(e) => setPresencaFilhos(e.value)} checked={presencaFilhos === 'Não'} />
                                <label>Não</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card-rodape-mulher">
                <Button
                    label="Voltar"
                    className="btn-1-mulher"
                    onClick={() => setStage(4)}
                />
                <Button
                    style={{ marginLeft: "10px" }}
                    label="Próximo"
                    className="btn-1-mulher"
                    onClick={() => setStage(6)}
                />
            </div>
        </div>

    );
}

export default RegistroOcorrencia;
